import React from 'react';

import { ButtonV3 } from '../../ButtonV3';
import type { ButtonV3Props } from '../../ButtonV3/ButtonV3';

import image from '../../../assets/images/footer/pre-auth-footer-img.png';

import {
  StyledFooter,
  FooterHeader,
  ImgContainer,
  TxtContainer,
  Br,
} from './PreAuthFooterV2.styles';

export type PreAuthFooterV2Props = {
  btnAction?: ButtonV3Props['onClick'];
  btnTxt?: string;
  hed?: string | JSX.Element;
  imgSrc?: string;
  imgTxt?: string;
  hideImg?: boolean;
};

export const PreAuthFooterV2: React.FC<PreAuthFooterV2Props> = ({
  btnAction,
  btnTxt,
  hed = (
    <span>
      Ready When <Br />
      You Are
    </span>
  ),
  imgSrc = image,
  imgTxt = 'Pre Auth Footer. Couple with drinks',
  hideImg = false,
}) => {
  return (
    <StyledFooter>
      {!hideImg && (
        <ImgContainer>
          <img src={imgSrc} alt={imgTxt} />
        </ImgContainer>
      )}
      <TxtContainer>
        <FooterHeader>{hed}</FooterHeader>
        {btnTxt && btnAction && (
          <ButtonV3 type="button" variant="primary" onClick={btnAction}>
            {btnTxt}
          </ButtonV3>
        )}
      </TxtContainer>
    </StyledFooter>
  );
};

export default PreAuthFooterV2;
